import { Directive, Inject, OnInit } from 'ng-metadata/core';
import { ContentService } from 'services/content.service';

/**
 * Hero Directive
 */
@Directive({
  selector: 'gwHero',
})
export class HeroDirective implements OnInit {

  constructor(
    @Inject('$scope') private $scope: ng.IScope,
    @Inject('$element') private $element: ng.IRootElementService,
    @Inject(ContentService) private contentService: ContentService,
  ) {}

  ngOnInit() {
    const desktop = window.matchMedia('(min-width: 61.25em)');

    if (desktop.matches) {
      const $video = this.$element.find('.js-gw-hero-bg-video');
      const videoSrc = $video.data('src');
      const $source = `<source type="video/mp4" src="${ videoSrc }" />`;
      $video.append($source);
    }

    /**
     * Handler event when search is updated.
     * Creates a new image of selected country and fades it in.
     */
    this.$scope.$on('search-change', async (e, data) => {
      const search = data.result;
      const content = await this.getCountryContent(search.value);
      const countries = ['IN', 'EG', 'CN', 'TR', 'JO'];

      const $video = this.$element.find('.js-gw-hero-bg-video');
      const $newVideo = $video.clone().empty();
      const $currImage = this.$element.find('.js-gw-hero-bg');
      const $newImage = $currImage.clone();

      if (desktop.matches && content.video) {
        $newVideo.append(`<source type="video/mp4" src="${ content.video }" />`);

        $newVideo
          .css('display', 'none')
          .attr('id', 'hero-' + search.value)
          .insertAfter($video)
          .fadeIn(600, () => {
            $video.remove();
          });

        $currImage.fadeOut(600);
        return;
      }

      if (content.background_img) {
        $newImage
          .css('display', 'none')
          .attr('id', 'hero-' + search.value)
          .attr('src', content.background_img)
          .insertAfter($currImage)
          .fadeIn(600, () => {
            $currImage.remove();
          });

        $video.fadeOut(600);
      }
    });
  }

  async getCountryContent(countryCode: string) {
    try {
      const response: any = await this.contentService
        .getCountryMeta(countryCode);
      return response.data;
    } catch (exception) {
      throw exception;
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/hero.directive.ts